// const qz = require("qz-tray");
const BrowserPrint = window.BrowserPrint;

// qz.api.setPromiseType(function promise(resolver) { return new Promise(resolver); });
//
// const createHash = require('sha.js');
// qz.api.setSha256Type(function(data) {
//   return createHash('sha256').update(data).digest('hex');
// });

export async function getPrinters() {
  return new Promise(function (resolve, reject) {
    BrowserPrint.getLocalDevices((printers) => resolve(printers));
  });
}

export function printZPL(printer, data) {
  return new Promise(function (resolve, reject) {
    try {
      printer.send(data, resolve, reject);
    } catch (e) {
      reject(e);
    }
  });
}

export function checkPrinterStatus(printer) {
  return new Promise(function (resolve, reject) {
    printer.sendThenRead(
      '~HQES', // Brqes before hqes
      function (text) {
        const errorString = 'ERRORS:         ';
        const ERRORS = text.substr(text.indexOf(errorString) + errorString.length, 19);
        const warningString = 'WARNINGS:       ';
        const WARNINGS = text.substr(text.indexOf(warningString) + warningString.length, 19);

        const statuses = [...parseError(ERRORS), ...parseWarning(WARNINGS)];
        if (!statuses.length) {
          statuses.push('Everything is OK');
        }
        resolve(statuses);
      },
      reject
    );
  });
}

function parseError(errorString) {
  if (!errorString) {
    console.warn('Missing printer error string; cannot parse error.');
    return [];
  }
  const [_a, _b, group1] = errorString.split(' ');

  const errors = [
    {
      index: 3, // _5
      errors: [
        { value: 0x08, error: 'Black Mark Not Found' },
        { value: 0x04, error: 'Black Mark Calibrate Error' },
        { value: 0x02, error: 'Retract Function timed out' },
        { value: 0x01, error: 'Paused' },
      ],
    },
    {
      index: 4, // _4
      errors: [
        { value: 0x08, error: 'Clear Paper Path Failed' },
        { value: 0x04, error: 'Paper Feed Error' },
        { value: 0x02, error: 'Presenter Not Running' },
        { value: 0x01, error: 'Paper Jam during Retract' },
      ],
    },
    {
      index: 5, // _3
      errors: [
        { value: 0x02, error: 'Printhead Thermistor Open' },
        { value: 0x01, error: 'Invalid Firmware Config' },
      ],
    },
    {
      index: 6, // _2
      errors: [
        { value: 0x08, error: 'Printhead Detection Error' },
        { value: 0x04, error: 'Bad Printhead Element' },
        { value: 0x02, error: 'Motor Over Temperature' },
        { value: 0x01, error: 'Printhead over Temperature' },
      ],
    },
    {
      index: 7, // _1
      errors: [
        { value: 0x08, error: 'Cutter Fault' },
        { value: 0x04, error: 'Head Open' },
        { value: 0x02, error: 'Ribbon Out' },
        { value: 0x01, error: 'Media Out' },
      ],
    },
  ];

  const warningMessages = [];
  for (const error of errors) {
    let datum = parseInt(group1[error.index], 16);
    for (const innerError of error.errors) {
      if (datum >= innerError.value) {
        datum = datum - innerError.value;
        warningMessages.push(innerError.error);
      }
    }
  }

  return warningMessages;
}

function parseWarning(warningString) {
  if (!warningString) {
    console.warn('Missing printer warning string; cannot parse warning.');
    return null;
  }
  const [_a, _b, group1] = warningString.split(' ');

  const errors = [
    {
      index: 5, // _3
      errors: [
        { value: 0x08, error: 'Sensor 8 at bin' },
        { value: 0x04, error: 'Sensor 7 in retract' },
        { value: 0x02, error: 'Sensor 6 - Retract Ready' },
        { value: 0x01, error: 'Sensor 5 - Presenter' },
      ],
    },
    {
      index: 6, // _2
      errors: [
        { value: 0x08, error: 'Sensor 4 - Loop Read' },
        { value: 0x04, error: 'Sensor 3 - Paper after Head' },
        { value: 0x02, error: 'Sensor 2 - Black Mark' },
        { value: 0x01, error: 'Sensor 1 - Paper before Head' },
      ],
    },
    {
      index: 7, // _1
      errors: [
        { value: 0x08, error: 'Paper Near End' },
        { value: 0x04, error: 'Replace Printhead' },
        { value: 0x02, error: 'Clean Printhead' },
        { value: 0x01, error: 'Need to Calibrate Media' },
      ],
    },
  ];

  const warningMessages = [];

  for (const error of errors) {
    let datum = parseInt(group1[error.index], 16);
    for (const innerError of error.errors) {
      if (datum >= innerError.value) {
        datum = datum - innerError.value;
        warningMessages.push(innerError.error);
      }
    }
  }

  return warningMessages;
}
